import React from 'react';

interface IButtonProps {
  content: string;
  redirect:string;
  handleClick?: () => void;
}

const SeeAllFaq = ({ content,redirect,handleClick}: IButtonProps) => {
  return (
    <div className="button-wrapper btn">
      <button
        type="submit"
        className={`button btn-havelock-blue`}
        data-event="globalClickEvent"
        onClick={() => {
            handleClick()
            let win = window.open(redirect, "_blank");
            win.focus();
        }}
        data-alt-text={content}
      >
        <span>{content}</span>
      </button>
    </div>
  );
};

export default SeeAllFaq;
